import { render } from "./SurveyBox.vue?vue&type=template&id=0dc1a2d2"
import script from "./SurveyBox.vue?vue&type=script&lang=js"
export * from "./SurveyBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__